<template>
  <v-dialog
    content-class="custom-scrollbar-width"
    v-model="dialog"
    persistent
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-app-bar dark fixed color="primary">
          <v-btn icon dark @click="closeFullScreenPopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Fee Plan Assign</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            class="mr-3"
            elevation="1"
            color="success"
            @click.prevent="saveFeePlan()"
          >
            Save
          </v-btn>
        </v-app-bar>
        <v-sheet class="mt-16">
          <v-container fluid>
            <v-row>
              <!-- <div key="1" class="inside"> -->
              <v-col cols="12" md="2" sm="4">
                <v-img :src="tots_image" width="120"></v-img>
              </v-col>

              <v-col
                cols="12"
                v-if="studentInfo.enquiryCode"
                sm="6"
                md="4"
                lg="2"
              >
                <div class="grey--text text-subtitle-2 mb-1">Enquiry Code</div>
                <div class="mb-1" v-text="studentInfo.enquiryCode"></div>
              </v-col>
              <v-col
                cols="12"
                v-if="studentInfo.enrollmentCode"
                sm="6"
                md="4"
                lg="2"
              >
                <div class="grey--text text-subtitle-2 mb-1">
                  Enrollment Code
                </div>
                <div class="mb-1" v-text="studentInfo.enrollmentCode"></div>
              </v-col>
              <v-col
                v-if="studentInfo.studentName || studentInfo.studentFirstName"
                cols="12"
                md="2"
                sm="4"
              >
                <div class="grey--text text-subtitle-2 mb-1">Student Name</div>
                <div
                  class="mb-1"
                  v-text="
                    studentInfo.studentFirstName
                      ? studentInfo.studentFirstName +
                        ' ' +
                        studentInfo.studentLastName
                      : studentInfo.studentName
                  "
                ></div>
              </v-col>
              <v-col cols="12" md="2" sm="4" v-if="studentInfo.franchisee">
                <div class="grey--text text-subtitle-2 mb-1">
                  Franchisee Name
                </div>
                <div
                  class="mb-1"
                  v-text="studentInfo.franchisee.companyName || '-'"
                ></div>
              </v-col>
              <v-col
                cols="12"
                md="2"
                sm="4"
                v-if="studentInfoDetails.franchisee"
              >
                <div class="grey--text text-subtitle-2 mb-1">
                  Franchisee Name
                </div>
                <div
                  class="mb-1"
                  v-text="studentInfoDetails.franchisee.companyName || '-'"
                ></div>
              </v-col>
              <v-col cols="12" md="2" sm="4" v-if="studentInfo.academicYear">
                <div class="grey--text text-subtitle-2 mb-1">Academic Year</div>
                <div
                  class="mb-1"
                  v-text="studentInfo.academicYear || '-'"
                ></div>
              </v-col>

              <v-col
                cols="12"
                md="2"
                sm="4"
                v-if="studentInfoDetails.franchiseeAcademicYear"
              >
                <div class="grey--text text-subtitle-2 mb-1">Academic Year</div>
                <div
                  class="mb-1"
                  v-text="
                    studentInfoDetails.franchiseeAcademicYear.academicYear ||
                    '-'
                  "
                ></div>
              </v-col>
              <v-col cols="12" md="2" sm="4" v-if="studentInfo.studentClass">
                <div class="grey--text text-subtitle-2 mb-1">Class</div>
                <div
                  class="mb-1"
                  v-text="studentInfo.studentClass.name || '-'"
                ></div>
              </v-col>
              <v-col cols="12" md="2" sm="4" v-if="studentInfoDetails.class">
                <div class="grey--text text-subtitle-2 mb-1">Class</div>
                <div
                  class="mb-1"
                  v-text="studentInfoDetails.class || '-'"
                ></div>
              </v-col>
              <!-- </div>
              <div class="inside" key="2"> -->
              <v-col cols="12" md="2" sm="4" v-if="studentInfo.fatherName">
                <div class="grey--text text-subtitle-2 mb-1">
                  Parent / Guardian Name
                </div>
                <div class="mb-1" v-text="studentInfo.fatherName"></div>
              </v-col>
              <v-col cols="12" md="2" sm="4" v-if="studentInfo.fatherMobile">
                <div class="grey--text text-subtitle-2 mb-1">
                  Parent / Guardian Mobile
                </div>
                <div
                  class="mb-1"
                  v-text="studentInfo.fatherMobile || '-'"
                ></div>
              </v-col>
              <v-col cols="12" md="4" v-if="studentInfo.fatherEmailID">
                <div class="grey--text text-subtitle-2 mb-1">
                  Parent / Guardian Email
                </div>
                <div
                  class="mb-1"
                  v-text="studentInfo.fatherEmailID || '-'"
                ></div>
              </v-col>
              <v-col cols="12" md="2" sm="4" v-if="studentInfo.gender">
                <div class="grey--text text-subtitle-2 mb-1">
                  Student Gender
                </div>
                <div
                  v-if="
                    studentInfo.gender === 'Male' ||
                    studentInfo.gender === 'MALE'
                  "
                  class="mb-1"
                  v-text="
                    studentInfo.gender === 'Male'
                      ? 'Boy'
                      : '-' || studentInfo.gender === 'MALE'
                      ? 'Boy'
                      : '-'
                  "
                ></div>
                <div
                  v-if="
                    studentInfo.gender === 'Female' ||
                    studentInfo.gender === 'FEMALE'
                  "
                  class="mb-1"
                  v-text="
                    studentInfo.gender === 'Female'
                      ? 'Girl'
                      : '-' || studentInfo.gender === 'FEMALE'
                      ? 'Girl'
                      : '-'
                  "
                ></div>
              </v-col>
              <v-col cols="12" v-if="studentInfo.section" sm="6" md="4" lg="2">
                <div class="grey--text text-subtitle-2 mb-1">
                  Section / Division
                </div>
                <div
                  class="mb-1"
                  v-text="studentInfo.section ? studentInfo.section : '-'"
                ></div>
              </v-col>
              <v-col
                cols="12"
                v-if="studentInfoDetails.section"
                sm="6"
                md="4"
                lg="2"
              >
                <div class="grey--text text-subtitle-2 mb-1">
                  Section / Division
                </div>
                <div
                  class="mb-1"
                  v-text="
                    studentInfoDetails.section
                      ? studentInfoDetails.section
                      : '-'
                  "
                ></div>
              </v-col>
              <!-- </div> -->
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col cols="12" md="6">
                <span class="body-2 font-weight-medium">
                  Select Fee Plan <span class="error--text">*</span>
                </span>
                <v-select
                  class="my-0 py-1"
                  @change="getTableList"
                  :items="infoArray"
                  key="id"
                  item-value="id"
                  item-text="name"
                  placeholder="--Select--"
                  name="feePlanSelect"
                  v-model="planID"
                  :rules="feePlanRule"
                  required
                >
                </v-select>
              </v-col>
              <!-- <v-col cols="12" md="6">
                <span class="body-2 font-weight-medium"> Do you want to assign Orders ? <span class="error--text">*</span> </span>
                <v-switch v-model="isAssignOrder" :label="isAssignOrder ? 'Yes' : 'No'" color="indigo" hide-details></v-switch>
              </v-col> -->
              <v-col cols="12" v-if="tableInfo.length > 0">
                <v-card-component>
                  <v-row>
                    <v-col cols="12" md="6">
                      <span class="body-3 font-weight-medium">
                        Choose type to apply on concession
                      </span>
                      <v-radio-group v-model="radio">
                        <v-radio
                          label="Percentage"
                          value="Percentage"
                        ></v-radio>
                        <v-radio label="Amount" value="Amount"></v-radio>
                      </v-radio-group>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span class="body-3 font-weight-medium">
                        Choose Concession Order
                        <span class="error--text">*</span>
                      </span>
                      <v-autocomplete
                        placeholder="--Select--"
                        class="my-0 py-1"
                        name="classSelect"
                        v-model="selectedOrder"
                        required
                        item-value="value"
                        :items="consessionOrder"
                        item-text="value"
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-data-table
                    v-model="checkedRows"
                    :single-select="singleSelect"
                    show-select
                    :headers="headers"
                    :items="tableInfo"
                    hide-default-footer
                    class="elevation-1"
                    item-key="id"
                    @item-selected="rowsReset"
                  >
                    <template v-slot:top>
                      <v-toolbar
                        flat
                        color="warning lighten-3"
                        class="d-flex justify-center"
                      >
                        <v-toolbar-title>Fee Structure</v-toolbar-title>
                      </v-toolbar>
                    </template>
                        <!-- Hide default header checkbox -->
                    <template v-slot:column.checkbox>
                      <th class="d-none"></th>
                    </template>

                    <template v-slot:item.data-table-select="{ item, isSelected, select }">
                        <v-simple-checkbox
                          :value="isSelected"
                          :readonly="item.disabled"
                          :disabled="item.disabled"
                          @input="selectAll(item)"
                        ></v-simple-checkbox>
                      </template>
                    <template v-slot:item.concessionRemark="{ item }">
                      <v-autocomplete
                        required
                        :disabled="!item.isCompulsory || item.feeType.name === 'Curriculum Fees'"
                        key="id"
                        v-model="item.selectedConcessionRemark"
                        menu-props="auto"
                        label="-- Remark--"
                        single-line
                        :items="item.concessionRemark"
                        item-text="name"
                        item-value="name"
                        @input="getDisabled(item)"
                      >
                      </v-autocomplete>
                    </template>
                    <template v-slot:item.manualConcAmountPer="{ item }">
                      <input
                        required
                        class="input"
                        :disabled="item.isDropdown"
                        maxLength="100"
                        :max="100"
                        :min="0"
                        :max-height="600"
                        @input="exceptEValidation($event, item)"
                        type="number"
                        v-model="item.manualConcAmountPer"
                      />
                    </template>
                    <template v-slot:body.append>
                      <tr>
                        <th class="text-center text-subtitle-2" colspan="2">
                          Totals
                        </th>
                        <th class="text-center text-subtitle-2">
                          <span class="mdi mdi-currency-inr"></span
                          >{{ totalAmount.toFixed(2) }}
                        </th>
                        <th class="text-center text-subtitle-2"></th>
                        <th
                          class="text-center text-subtitle-2"
                          v-if="radio !== 'Amount'"
                        ></th>
                        <th
                          class="text-center text-subtitle-2"
                          v-if="radio === 'Amount'"
                        >
                          <span class="mdi mdi-currency-inr"></span
                          >{{ totalConcessionAmount.toFixed(2) }}
                        </th>
                        <th
                          class="text-center text-subtitle-2"
                          v-if="radio === 'Percentage'"
                        >
                          <span class="mdi mdi-currency-inr"></span
                          >{{ totalAmountWithConcession.toFixed(2) }}
                        </th>
                        <th class="text-center text-subtitle-2">
                          <span class="mdi mdi-currency-inr"></span
                          >{{ totalAmountAfterConcession.toFixed(2) }}
                        </th>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-component>
              </v-col>
            </v-row>
          </v-container>
        </v-sheet>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
import constants from '@/utils/constants'
import _ from 'lodash'
import VCardComponent from '../../template/VCardComponent.vue'
export default {
  name: 'AssignFeePlan',
  components: { VCardComponent },
  props: ['enquiryID', 'type', 'STUDENT_DATA'],
  data () {
    return {
      totalAmountAfterConcession: 0,
      totalAmount: 0,
      totalConcessionAmount: 0,
      totalAmountWithConcession: 0,
      singleSelect: false,
      radio: 'Percentage',
      tots_image: `${constants.RAZORPAY.TOTS_IMAGE}`,
      studentInfo: {},
      studentInfoDetails: {},
      dialog: true,
      paginated: false,
      valid: true,
      perPage: 10,
      loadingComponent: null,
      isCustom: false,
      infoArray: [],
      planID: '',
      headers: this.getHeaders(),
      info: {},
      response: [],
      orderID: '',
      isConcession: false,
      franchiseeID: '',
      concessionInfo: [],
      concessionID: '',
      conAdjsuType: '',
      manualConcAmount: '',
      installmentInfo: [],
      tableInfo: [],
      checkedRows: [],
      consessionOrder: [
        { id: 1, value: 'Ascending' },
        { id: 2, value: 'Descending' },
        { id: 2, value: 'Equal' }
      ],
      selectedOrder: 'Descending',
      isAssignOrder: false, // By default this is false
      feePlanRule: [(v) => !!v || ' Fee plan is required']
    }
  },
  watch: {
    planID: function (value) {
      if (_.isEmpty(value)) {
        this.concessionID = ''
        this.conAdjsuType = ''
      }
    },
    concessionID: function (value) {
      if (value === '') {
        this.concessionID = ''
        this.conAdjsuType = ''
      }
    },
    radio: function (val) {
      this.getTableList()
    },
    checkedRows: function (values) {
      this.calculatePayAmount()
    }
  },
  async created () {
    if (
      this.STUDENT_DATA.newStudentAdmission &&
      this.STUDENT_DATA.newStudentAdmission.studentEnrollment
    ) {
      this.studentInfo = this.STUDENT_DATA.newStudentAdmission.studentEnrollment
      this.studentInfoDetails = this.STUDENT_DATA.newStudentAdmission
      this.studentInfo.studentFirstName = this.studentInfo.studentFirstName
        ? this.studentInfo.studentFirstName
        : ''
      this.studentInfo.studentLastName = this.studentInfo.studentLastName
        ? this.studentInfo.studentLastName
        : ''
    } else {
      this.studentInfo = this.STUDENT_DATA
      this.studentInfo.studentFirstName = this.studentInfo.studentFirstName
        ? this.studentInfo.studentFirstName
        : ''
      this.studentInfo.studentLastName = this.studentInfo.studentLastName
        ? this.studentInfo.studentLastName
        : ''
    }
    await this.getAllInfo()
    this.isConcession = false
  },
  computed: {},
  methods: {
    closeFullScreenPopup () {
      this.dialog = false
      this.$emit('setIsCompop', this.dialog)
    },
    selectAll (event) {
      if (event.value) {
        _.map(event.items, (obj) => {
          obj.isCompulsory = !obj.isCompulsory || true
          obj.isDropdown = true
          obj.manualConcAmount = 0
          obj.manualConcAmountPer = 0
          obj.selectedConcessionRemark = ''
          obj.totalAmountAfterConcession = obj.amount
        })
      } else {
        event.isCompulsory = !event.isCompulsory || false
        event.totalAmountAfterConcession = event.amount
        event.isDropdown = true
        if (event.isCompulsory === true) {
          this.checkedRows.push(event)
        } else {
          this.checkedRows = this.checkedRows.filter(item => item.id !== event.id)
          event.totalAmountAfterConcession = 0
        }
      }
    },
    calculatePayAmount () {
      this.totalAmount = 0
      this.totalConcessionAmount = 0
      this.totalAmountWithConcession = 0
      this.totalAmountAfterConcession = 0
      _.forEach(this.checkedRows, (item) => {
        this.totalAmount = this.addTwoNumber(this.totalAmount, item.amount)
        this.totalConcessionAmount = this.addTwoNumber(
          this.totalConcessionAmount,
          Number(item.manualConcAmountPer)
        )
        this.totalAmountWithConcession = this.addTwoNumber(
          this.totalAmountWithConcession,
          Number(item.manualConcAmount)
        )
        this.totalAmountAfterConcession = this.addTwoNumber(
          this.totalAmountAfterConcession,
          Number(item.totalAmountAfterConcession)
        )
      })
    },
    addTwoNumber (num1, num2) {
      return this.toFixed(Number(num1) + Number(num2))
    },
    toFixed (number, length = 2) {
      return Number(Number(number).toFixed(length))
    },
    rowsReset (value) {
      console.log('Inside Row Reset Rows---', value)
      value.item.isCompulsory = !value.item.isCompulsory
      if (!value.item.isCompulsory) {
        value.item.manualConcAmount = 0
        value.item.manualConcAmountPer = 0
        value.item.totalAmountAfterConcession = 0
        value.item.selectedConcessionRemark = ''
      } else {
        value.item.totalAmountAfterConcession = value.item.amount
      }
      value.isDropdown = !value.isDropdown
    },
    getHeaders () {
      let header = [
        { text: 'Fee Type', value: 'feeType.name', align: 'center' },
        { text: 'Amount', value: 'amount', align: 'center' },
        {
          text: 'Concession Remark',
          value: 'concessionRemark',
          align: 'center'
        }
      ]
      if (this.radio === 'Percentage') {
        header.push({
          text: 'Concession %',
          value: 'manualConcAmountPer',
          align: 'center'
        })
        header.push({
          text: 'Concession Amount',
          value: 'manualConcAmount',
          align: 'center'
        })
      } else {
        header.push({
          text: 'Concession Amount INR',
          value: 'manualConcAmountPer',
          align: 'center'
        })
      }
      header.push({
        text: 'Amount To pay ',
        value: 'totalAmountAfterConcession',
        align: 'center'
      })
      header.push({ text: '', value: 'data-table-expand' })
      return header
    },
    getDisabled: function (item) {
      const index = this.tableInfo.findIndex((ele, index) => {
        if (ele.id === item.id) {
          return true
        }
      })
      let udatedData = item
      if (item.selectedConcessionRemark) {
        if (item.feeType.name === 'Curriculum Fees') {
          udatedData.isDropdown = true //  Disable manual fields
        } else {
          udatedData.isDropdown = false
        }
      } else {
        udatedData.isDropdown = true
        udatedData.manualConcAmount = 0
        udatedData.manualConcAmountPer = 0
      }
      udatedData.manualConcAmount = 0
      this.tableInfo.splice(index, 1, udatedData)
    },
    saveFeePlan: async function (planConformation = 'no') {
      try {
        if (!this.planID) {
          return this.$dialog.error({
            text: ` Select Plan`,
            title: 'Error'
          })
        }
        let formData = {
          planConformation: planConformation,
          feeComponentID: this.planID,
          isAssignOrder: this.isAssignOrder ? this.isAssignOrder : 'false',
          feeType: _.map(this.checkedRows, (item) => {
            let obj = {
              id: item.id,
              // feeConcessionID: item.concessionID,
              concessionAmount: item.manualConcAmount,
              concessionOrder: this.selectedOrder
            }
            if (item.selectedConcessionRemark) {
              obj.concessionRemark = item.selectedConcessionRemark
            }
            return obj
          })
        }
        if (this.type) {
          formData.admissionID = this.enquiryID
        } else {
          formData.enquiryID = this.enquiryID
        }
        // if (this.manualConcAmount) {
        //   formData.amount = this.manualConcAmount
        // }
        if (this.concessionID) {
          formData.feeConcessionID = this.concessionID
        }
        this.loadingComponent = this.$buefy.loading.open()
        if (this.type) {
          await http.post(
            `${constants.API_URL}/api/promotion/assign-fee-component`,
            formData
          )
        } else {
          let res = await http.post(
            `${constants.API_URL}/api/assign-fee-component`,
            formData
          )
          if (res.status === 200 && res.data.status === 'fail') {
            this.loadingComponent.close()
            this.callFeePlanOnPlanConfirmation(res.data.message)
            return
          }
        }

        this.loadingComponent.close()
        this.dialog = false
        this.$emit('setIsCompop', this.dialog)
        return this.$dialog.info({
          text: `Assigned Successfully`,
          title: 'Success'
        })
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('error in fetching data : ', errorMessage)
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      }
    },
    async callFeePlanOnPlanConfirmation (failedMsg) {
      this.$dialog.confirm({
        text: failedMsg,
        title: 'Confirm',
        type: 'error',
        actions: {
          false: {
            color: 'error',
            text: 'Cancel',
            handle: () => {
              this.$nextTick(() => {
                return false
              })
            }
          },
          true: {
            color: 'success',
            text: 'Ok',
            handle: async () => {
              this.saveFeePlan('yes')
            }
          }
        }
      })
    },
    getTableList: async function () {
      this.checkedRows = []
      if (this.planID) {
        _.map(this.infoArray, (item) => {
          if (item.id === this.planID) {
            this.tableInfo = item.feeComponentFeeTypeMaps
          }
        })
      } else {
        this.tableInfo = []
      }
      _.map(this.tableInfo, (element) => {
        element.concessionRemark = [
          { id: 1, name: 'Sibling Concession' },
          { id: 2, name: 'Staff Concession' },
          { id: 3, name: 'One-shot Payment Concession' },
          { id: 4, name: 'Referral Concession' },
          { id: 5, name: 'General / Other Concession' }
        ]
        element.manualConcAmount = 0
        element.manualConcAmountPer = 0
        if (element.isCompulsory) {
          element.totalAmountAfterConcession = element.amount
        } else {
          element.totalAmountAfterConcession = 0
          element.isCompulsory = false
        }
        element.selectedConcessionRemark = ''
        element.isDropdown = true
        if (element.isCompulsory === true) {
          // element.disabled = true
          this.checkedRows.push(element)
        }
      })
      _.forEach(this.tableInfo, (obj) => {
        if (obj.isCompulsory === true) {
          obj.disabled = true
        } else {
          obj.disabled = false
        }
      })
      this.headers = this.getHeaders()
      this.calculatePayAmount()
    },
    exceptEValidation: function (event, item) {
      let amountPer = Number(event.target.value)
      if (this.radio === 'Percentage') {
        if (amountPer < 0) {
          amountPer = 0
        } else if (amountPer > 100) {
          amountPer = 100
        }
        item.manualConcAmountPer = amountPer
        item.manualConcAmount = ((item.amount * amountPer) / 100).toFixed(2)
        item.totalAmountAfterConcession =
          item.amount - ((item.amount * amountPer) / 100).toFixed(2)
      } else {
        if (item.amount > amountPer) {
          item.manualConcAmountPer = amountPer
          item.manualConcAmount = item.manualConcAmountPer
          item.totalAmountAfterConcession = (item.amount - amountPer).toFixed(2)
          if (
            item.manualConcAmount < 0 ||
            item.manualConcAmountPer === 0 ||
            item.manualConcAmountPer === ''
          ) {
            item.manualConcAmountPer = 0
            item.manualConcAmount = 0
          }
        } else {
          item.manualConcAmountPer = 0
          item.manualConcAmount = 0
          item.totalAmountAfterConcession = item.amount
        }
      }
      this.calculatePayAmount()
    },
    // getInstallmentList: async function () {
    //   if (this.planID) {
    //     await this.getInstallmentInfo()
    //   }
    // },
    // selectedConcession: async function (conID) {
    //   if (conID) {
    //     _.map(this.concessionInfo, item => {
    //       if (item.id === conID) {
    //         this.conAdjsuType = item.adjustType
    //       }
    //     })
    //     if (this.planID) {
    //       await this.getInstallmentInfoByConcessionID()
    //     } else {
    //       this.concessionID = ''
    //       this.conAdjsuType = ''
    //       return this.$dialog.error({
    //         text: ` Please select fee plan`,
    //         title: 'Error'
    //       })
    //     }
    //   } else {
    //   }
    // },
    // onradioChange: async function () {
    //   if (this.isConcession) {
    //     await this.getConcessionInfo()
    //   } else {
    //     this.conAdjsuType = ''
    //     this.concessionID = ''
    //     this.tableInfo = []
    //     this.planID = ''
    //   }
    // },
    getAllInfo: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        if (this.type) {
          let { data } = await http.get(
            `${constants.API_URL}/api/fee-component-by-admission/${this.enquiryID}`
          )
          this.infoArray = data
          this.info = data[0] || {}
        } else {
          let { data } = await http.get(
            `${constants.API_URL}/api/fee-component-by-enquiry/${this.enquiryID}`
          )
          this.infoArray = data
          this.info = data[0] || {}
        }
        if (this.info) {
          _.map(this.info.feeComponentFranchiseeMaps, (item) => {
            this.franchiseeID = item.franchiseeID
          })
        }
        this.loadingComponent.close()
        if (!this.info) {
          this.total = 0
        } else {
          this.total = this.info.length
        }
        this.headers = this.getHeaders()
      } catch (e) {
        this.loadingComponent.close()
        this.dialog = false
        this.$emit('setIsCompop', this.dialog)
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.concessionID = ''
        this.conAdjsuType = ''
        this.planID = ''
        this.tableInfo = []
        console.log('error in fetching data : ', errorMessage)
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      }
    }
    // getConcessionInfo: async function () {
    //   try {
    //     this.loadingComponent = this.$buefy.loading.open()
    //     let { data } = await http.get(`${constants.API_URL}/api/concessions?academicYearID=${this.info.academicYearID}&franchiseeID=${this.franchiseeID}`)
    //     this.concessionInfo = data
    //     this.loadingComponent.close()
    //     if (!this.concessionInfo) {
    //       this.total = 0
    //     } else {
    //       this.total = this.info.length
    //     }
    //   } catch (e) {
    //     this.loadingComponent.close()
    //     const errorMessage = (e && e.response && e.response.data.message) || e.message
    //     console.log('error in fetching data : ', errorMessage)
    //     this.concessionID = ''
    //     this.conAdjsuType = ''
    //     this.planID = ''
    //     return this.$dialog.error({
    //       text: ` ${errorMessage}`,
    //       title: 'Error'
    //     })
    //   }
    // },
    // getInstallmentInfoByConcessionID: async function () {
    //   try {
    //     this.infoArray = []
    //     this.loadingComponent = this.$buefy.loading.open()
    //     let response = await http.get(`${constants.API_URL}/api/custom-fee-component?feeConcessionID=${this.concessionID}&feeComponentID=${this.planID}`)
    //     this.infoArray.push(response.data)
    //     await this.getTableList()
    //     this.loadingComponent.close()
    //     if (!this.concessionInfo) {
    //       this.total = 0
    //     } else {
    //       this.total = this.info.length
    //     }
    //   } catch (e) {
    //     this.loadingComponent.close()
    //     this.concessionID = ''
    //     this.conAdjsuType = ''
    //     this.planID = ''
    //     this.tableInfo.length = 0
    //     await this.getAllInfo()
    //     const errorMessage = (e && e.response && e.response.data.message) || e.message
    //     console.log('error in fetching data : ', errorMessage)
    //     return this.$dialog.error({
    //       text: ` ${errorMessage}`,
    //       title: 'Error'
    //     })
    //   }
    // }
  }
}
</script>
<style>
div.custom-scrollbar-width::-webkit-scrollbar {
  width: 1.5em;
}
div.custom-scrollbar-width::-webkit-scrollbar-track {
  background: #f1f1f1;
}
div.custom-scrollbar-width::-webkit-scrollbar-thumb {
  background: #888;
}
div.custom-scrollbar-width::-webkit-scrollbar-thumb:hover {
  background: #555;
}
th .v-data-table__checkbox {
  display: none;
}
</style>
